<style src="css/agoar.css" scoped></style>
<style scoped>
    .circular{
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        background: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .nei{
        width: 2rem;
        height: 2rem;
        background: #fff;
        border-radius: 50%;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="通话"></topbar>
        <div class="box">
            <div id="video">
                <div class="circular">
                    <div class="nei"></div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,

            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/agoar.vue